import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="py-14 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading">{siteInfo.name}</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">{siteInfo.description}</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">内容分类</h4>
            <div className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">快速链接</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">首页</Link>
              <Link to="/category/latest" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">最新热播</Link>
              <Link to="/category/recommended" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">口碑推荐</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">联系方式</h4>
            <div className="flex flex-col gap-3 text-sm text-background-400">
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-xs"></i>
                </div>
                <span>{siteInfo.email}</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-xs"></i>
                </div>
                <span>{siteInfo.phone}</span>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-xs"></i>
                </div>
                <span>{siteInfo.address}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}